














import Vue, { PropType } from 'vue'

type Value = string | number | boolean

type Props = {
  label: string
  value: Value
}

export type RadioProps = Props

export default Vue.extend<{}, {}, {}, Props>({
  name: 'XRadio',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number, Boolean] as PropType<Value>,
      required: true,
    },
  },
  methods: {
    updateValue(value: Value) {
      this.$emit('change', value)
    },
  },
})
